module.exports = __webpack_public_path__ + "static/media/Shaker808.f2b8fd67.wav";